import { VehicleDetailsGroupAddInput } from './vehicle-details-group-add-input.model';


export class VehicleGroupAddInput implements IVehicleGroupAddInput {
    /** The vehicle group name with 255 character limit */
    vehicleGroupName!: string;
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The description with 500 character limit */
    description!: string;
    vehicleDetailsGroup!: VehicleDetailsGroupAddInput[];

    constructor(data?: IVehicleGroupAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleGroupName = _data["vehicleGroupName"];
            this.companyDetailsId = _data["companyDetailsId"];
            this.description = _data["description"];
            if (Array.isArray(_data["vehicleDetailsGroup"])) {
                this.vehicleDetailsGroup = [] as any;
                for (let item of _data["vehicleDetailsGroup"])
                    this.vehicleDetailsGroup!.push(VehicleDetailsGroupAddInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleGroupAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleGroupAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleGroupName"] = this.vehicleGroupName;
        data["companyDetailsId"] = this.companyDetailsId;
        data["description"] = this.description;
        if (Array.isArray(this.vehicleDetailsGroup)) {
            data["vehicleDetailsGroup"] = [];
            for (let item of this.vehicleDetailsGroup)
                data["vehicleDetailsGroup"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IVehicleGroupAddInput {
    /** The vehicle group name with 255 character limit */
    vehicleGroupName: string;
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The description with 500 character limit */
    description: string;
    vehicleDetailsGroup: VehicleDetailsGroupAddInput[];
}

